import { hydrateRoot } from 'react-dom/client';

import MainApp from './main';
import reportWebVitals from './reportWebVitals';

hydrateRoot(document.getElementById('root'), <MainApp />);

reportWebVitals();
